import React from "react";
import { useEffect } from "react";
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import { useMsal, useMsalAuthentication, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "./infrastructure/auth/authConfig";
import UserProvider from "./components/Context/UserProvider";
import InitialAppDataProvider from "./components/Context/InitialAppDataProvider";
import { AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./services/telemetryService";
import appStyles from "./AppStyles";
import AppRouter from "./AppRouter";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import TenantProvider from "./components/Context/TenantProvider";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_DATAGRID_LICENSE);

const App: React.FC = () => {
	const classes = appStyles();

	// Auth logic
	const { login, error } = useMsalAuthentication(InteractionType.Silent, loginRequest);
	const { inProgress } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	useEffect(() => {
		if (error) {
			login(InteractionType.Redirect);
		}
	}, [error, login]);

	if (!isAuthenticated) {
		return <>Not signed in</>;
	} else if (inProgress === InteractionStatus.Login) {
		return <>Loading....</>;
	} else {
		return (
			<UserProvider>
				<AppInsightsContext.Provider value={reactPlugin}>
					<InitialAppDataProvider>
						<TenantProvider>
							<div className={classes.root}>
								<AppInsightsErrorBoundary onError={() => <h1>Something&apos;s gone wrong.</h1>} appInsights={reactPlugin}>
									<AppRouter />
								</AppInsightsErrorBoundary>
							</div>
						</TenantProvider>
					</InitialAppDataProvider>
				</AppInsightsContext.Provider>
			</UserProvider>
		);
	}
};
export default App;
